import { User } from '@intelligent-play-v2/domain';
import { queryBuilder } from '../queryBuilder';

export const postUser = async (params: Partial<User>): Promise<User> => {
  const { data } = await queryBuilder('POST', 'admin/users', undefined, {
    ...params,
  });
  return data;
};
